<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      disable: true,
      gray: true,
      cur: -1,
      curId: "",
      pm: {},
      datum: [],
      buyNoworMakeOfferBtn: "Select now"
    };
  },
  created() {
    var that = this;
    that.getPropertyRoomLst({
      params: that.$route.query.pid,
      callback: that.callback
    });
  },
  components: {},
  methods: {
    ...mapActions("property", ["getPropertyRoomLst"]),
    reservePropertyForm() {
      // need to add the property id and room id. or is room id enough?
      this.$router.push({
        path: "/property/form",
        query: {
          pid: this.$route.query.pid,
          rid: this.curId,
          type: this.buyNoworMakeOfferBtn == "Select now" ? 2 : 1
        }
      });
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.datum = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    choosed(index, roomId, status) {
      console.log(" AAA choosed clicked");
      if (status == "Available") {
        var that = this;
        if (index !== that.cur) {
          that.cur = index;
          that.curId = roomId;
          that.disable = false;
        } else {
          that.cur = -1;
          that.curId = "";
          that.disable = true;
        }
      }
      console.log("choosed clicked", index);
      this.buyNoworMakeOfferBtn = this.getOfferType(index);
    },
    getOfferType(index) {
      let totalprice = this.datum[index].totalPrice;
      let totalpriceMax = this.datum[index].totalPriceMax;
      let type = "Make Offer";

      if (totalprice && totalpriceMax && totalprice == totalpriceMax) {
        type = "Select now"; //fixed price
      } else if (totalprice && totalpriceMax) {
        type = "Make Offer"; //ranged
      } else if (totalprice && totalpriceMax == null) {
        type = "Select now"; //fixed price
      } else if (totalprice == null && totalpriceMax == null) {
        type = "Make Offer"; //no price
      } else if (totalprice && totalpriceMax == 0) {
        type = "Select now"; //fixed price
      }
      return type;
    }
  }
};
</script>

<template>
  <el-row style="padding: 10px; background-color: #ffffff">
    <el-col :span="24">
      <div
        style="border: 4px solid #cccccc; border-radius: 30px; padding: 20px;"
      >
        <el-row>
          <el-col :span="24" class="center-col">
            <span class="property-selection-title"
              >Select your new property</span
            >
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="property-selection-desc">
              Congratulations on selecting your brand-new property!
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="property-selection-desc"
              >Take advantage of UNIFI Property’s unique online reservation
              function to reserve this property
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="property-selection-desc"
              >exclusively for you, for the next 7 days
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="property-selection-desc">
              To start the process, select which of the available properties you
              would like to reserve
            </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px" :gutter="20">
          <el-col :span="8">
            <span class="label-available full-width text-style"
              >Available<br />Properties</span
            >
          </el-col>
          <el-col :span="8">
            <span class="label-sold full-width text-style"
              >Sold<br />Properties</span
            >
          </el-col>
          <el-col :span="8">
            <span class="label-reserved full-width text-style"
              >Reserved<br />Properties</span
            >
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          style="margin-top: 10px; display: flex; justify-content: center; flex-wrap: wrap"
        >
          <el-col
            :span="12"
            v-for="(item, index) in datum"
            :key="index"
            class="prop-tile"
          >
            <span
              :class="{
                'btn-prop-res': true,
                reserved: item.status == 'Reserved',
                sold:
                  item.status == 'Sold' ||
                  item.status == 'Unconditional' ||
                  item.status == 'Settled',
                available: item.status == 'Available',
                choosed: index == cur
              }"
              @click="choosed(index, item.roomId, item.status)"
            >
              {{ item.apt }}
            </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="24" style="display: flex; flex-direction: column">
            <el-button
              :class="{
                'selection-continue disabled': datum.length === 0 || cur === -1,
                'selection-continue': datum.length > 0 && cur !== -1
              }"
              :disabled="datum.length === 0 || cur === -1"
              @click="reservePropertyForm"
              >{{ buyNoworMakeOfferBtn }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.property-selection-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
}

.property-selection-desc {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  text-align: center;
  font-size: 18px;
}

.center-col {
  display: flex;
  justify-content: center;
}

.selection-continue {
  border-top-right-radius: 20px;
  background-color: #003333;
  width: 100%;
  color: #ffffff;
  padding: 10px 0;
  font: 500 20px DINosaur-a, sans-serif;
}

.selection-continue.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.label-available {
  font-family: DINosaur-a, sans-serif;
  color: #000000;
  background-color: #ffffff;
  border: 4px solid #cccccc;
  font-size: 16px;
  font-weight: 400;
  padding-top: 5px;
  padding-bottom: 5px;
}

.label-sold {
  font-family: DINosaur-a, sans-serif;
  color: #ffffff;
  background-color: #cccccc;
  border: 4px solid #cccccc;
  font-size: 16px;
  font-weight: 400;
  padding-top: 5px;
  padding-bottom: 5px;
}

.label-reserved {
  font-family: DINosaur-a, sans-serif;
  color: #ffffff;
  background-color: #003333;
  border: 4px solid #003333;
  font-size: 16px;
  font-weight: 400;
  padding-top: 5px;
  padding-bottom: 5px;
}

.full-width {
  display: flex;
  justify-content: center;
}

.text-style {
  text-align: center;
  word-wrap: break-word;
}

.prop-tile {
  margin: 1% 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.btn-prop-res {
  font-family: DINosaur-a, sans-serif;
  font-size: 20px;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

.available {
  background-color: #ffffff;
  border: 4px solid #cccccc;
}

.sold {
  background-color: #cccccc;
  border: 4px solid #cccccc;
}

.reserved {
  background-color: #003333;
  border: 4px solid #003333;
  color: #ffffff;
}

.choosed {
  background: #757575;
  color: #ffffff;
}

.selection-continue {
  border-top-right-radius: 30px;
  background-color: #003333;
  color: #ffffff;
  font: 400 20px DINosaur-a, sans-serif;
  transition: font-size 0.3s ease-in-out;
}

.selection-continue:hover {
  font: 400 21px DINosaur-a, sans-serif;
}

.selection-continue.disabled {
  opacity: 0.6;
  background-color: #003333;
  cursor: not-allowed;
}

.selection-continue.disabled:hover {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/propertySelection.vue